import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getSubTasks } from "../../actions/userActions/subTaskAction";
import Loader from "../subComponents/Loader";
import Search from "../subComponents/search/Search";
import AddButton from "../subComponents/buttons/AddButton";
import { IconButton,Tooltip } from "@mui/material";
import Pagination from '../paginatioin/pagination';
import EditButton from "../subComponents/buttons/EditButton";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import CustomButton from "../subComponents/buttons/CustomButton";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import SearchInput from "../subComponents/search/SearchInput";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import Heading6Regular from "../designSystem/Heading6Regular";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import AddSubTasks from "./AddSubTasks";

function SubTasks() {
 const [currentPage, setCurrentPage] = useState(1)
  const [previousQuery, setPreviousQuery] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();

  const subTasks = useSelector((state) => state.sub_tasks_reducer.subTasks);
  const subTasksData = subTasks && subTasks.result;
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [SubtaskData, setSubtaskData] = useState([]);
  const totalItems = subTasks?.totalCount  || 0;
  const totalPages = subTasks?.totalPages || 0;
  const itemsPerPage =10;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const [query, setQuery] = useState("");
  
  useEffect(() => {
    const pageNumber = currentPage;
  
      if (query !== previousQuery) {
        setCurrentPage(1);
      }
      dispatch(getSubTasks(pageNumber, SIZE_OF_PAGE, query));
      setPreviousQuery(query);
  
    }, [currentPage, query]);
  
  
  const handleEditSubTask = (row) => {
    setEditData(row);
    setShowModal(true);
  };
  useEffect(() => {
    const SubtasksData = subTasksData?.map((subTasks) => ({
      ...subTasks,
      status: (
        <span
          style={{
            background: "#4361FF1A",
            width: "56px",
            height: "26px",
            padding: "3px 8px",
            display: "inline-block",
            textAlign: "center",
            lineHeight: "20px",
            borderRadius: "4px 0px 0px 0px",
            opacity: 1 ,
          }}
        >
          {subTasks.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    setSubtaskData(SubtasksData);
  }, [subTasks]);
 
 
  const columns = [
    { label: "Name", accessor: "name" },
    { label: "Description", accessor: "description" },
    {
      label: "Status",
      accessor: "status",
      render: (rowData) => <AddSubTasks active={rowData.active} />,
    },
  ];
  const actions = [  
    {
        label: 'Edit SubTask',
        icon: <EditOutlinedIcon />,
        permission: 'CanUpdateSubTask',
        handler:handleEditSubTask,
    },
];
const handleSaveData = async () => {
  dispatch(getSubTasks(currentPage, SIZE_OF_PAGE, query));
  setShowModal(false);
};
const handleAddClick = () => {
  setEditData(null);
  setShowModal(true);
};
const handleCloseModal = () => {
  setShowModal(false);
};
const handleSearchChange = (e) => {
  setQuery(e.target.value);
  setCurrentPage(1);
};
  return (
    <>
    <div className="main-container">
            <div className="content-header">
                <div className="header-navigation">
                    <BodySmallMedium text="Manage" color="#A1A2A4" />
                    <img
                        src={chevron_rightIcon} alt="Chevron Right" className="chevron-right-icon" />
                    <BodySmallMedium text="subTasks" color="#1E293B" />

                </div>
            </div>
            <Heading6Regular text="subTasks" color="#1E293B" />
            <div className="content-wrapper">
                <div className="pagination">
                    <SearchInput
                        placeholder="Search"
                        onChange={handleSearchChange}
                        value ={query}
             />
                    <div style={{ display: "flex", alignItems: "center" }}>
                       <CustomPagination
                        currentPage={currentPage}
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        totalPages={totalPages}
                        onPageChange={(page) => setCurrentPage(page)} 
                      />
                     {permissions && permissions.includes("CanAddSubTask") && (
                            <CustomButton text="Add SubTask" width="180px" onClick={handleAddClick} />
                        )}
                    </div>
                </div>
                <DynamicTable
                    data={ SubtaskData}
                    isLoading={subTasks === "isLoading"}
                    columns={columns}
                    permissions={permissions}
                    actions={actions}
                    thIcon={thIcon}
                />
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
    { totalItems > 0 && (
      <CustomPagination
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
      />
    )}
    </div>
            </div>
            {showModal && (
        <AddSubTasks
          onClose={handleCloseModal}
          editData={editData}
          onSave={handleSaveData}
        />
      )}
        </div>
    </>
  );
}

export default SubTasks;
